import { useCallback } from 'react';
import { message } from 'antd';
import { setSmartDefaultsCache } from '../../../../../utils/smartDefaults';
import { useProductDefaultSettings } from './useProductDefaultSettings';
import { saveAndSyncProductDefaultSettings } from './productDefaultSettingsApi';

export const useSmartDefaults = (token) => {
    const { defaults, loading, error, reload, setDefaults } = useProductDefaultSettings(token);

    const saveDefaults = useCallback(
        async (nextDefaults, { overwriteAll = false } = {}) => {
            if (!token) {
                message.error('Not authenticated');
                return { success: false };
            }

            const result = await saveAndSyncProductDefaultSettings(token, defaults, nextDefaults, {
                overwriteAll,
            });

            if (!result.success) {
                message.error(result.message || 'Failed to save product defaults.');
                if (result.defaults) {
                    setDefaults(result.defaults);
                    setSmartDefaultsCache(result.defaults);
                }
                return result;
            }

            setDefaults(result.defaults);
            setSmartDefaultsCache(result.defaults);
            message.success(result.message);

            return result;
        },
        [token, defaults, setDefaults]
    );

    return { defaults, loading, error, reload, saveDefaults };
};
